import React from 'react'
import styles from './CustomSwitch.module.css'

const CustomSwitch = ({checked,onChange,isDisable=false}) => {
  return (
    <label className={styles["switch"]}>
      <input disabled={isDisable} checked ={checked} onChange={onChange} type="checkbox" />
      <span className={isDisable ? `${styles['slider']} ${styles['disabled']}` : styles['slider'] }></span>
    </label>

  )
}

export default CustomSwitch